export const privacySelect = [
    {value: false, label: '全体に公開'},
    {value: true, label: '友達まで公開'}
]